/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { Epic } from 'redux-observable';
import PortalWebsiteService from 'src/js/api/services/PortalWebsiteService';
import { PortslWebsiteUpdateFields } from 'src/js/models/Portal';
import { getPortalWebsites, UPDATE_PORTAL_WEBSITE } from 'src/js/redux/actions/PortalWebsite';
import { showMessage } from '../../actions/index';
import { Create, Request } from '../EpicUtils';

const request: Request<any, PortslWebsiteUpdateFields> = {
  type: UPDATE_PORTAL_WEBSITE,
  getData: (args) => PortalWebsiteService.updatePortalWebsite(
    ...args
  ),
  processData: (value, state, payload) => [
    getPortalWebsites(!payload[0]),
    showMessage({message: 'Portal website updated', success: true})
  ]
};

export const EpicUpdatePortalWebsite: Epic<any, any> = Create(request);